<div class="row">
    <div class="my-auto p-0 m-0 col-1 text-center">
        <i class="material-icons mr-1 pointer fas fa-chevron-left custom-collapsable" *ngIf="metricPages.length > 1"
            (click)="changePage(false)"></i>
    </div>
    <div class="col-10">
        <div class="row">
            <div *ngFor="let metric of metricPages[selectedPage]; let i = index" class="p-0 mb-2"
                [ngClass]="{'col': metricPages[selectedPage].length >= 6, 'col-2': metricPages[selectedPage].length === 5,
                        'col-3': metricPages[selectedPage].length === 4, 'col-4': metricPages[selectedPage].length === 3,
                         'col-6': metricPages[selectedPage].length === 2, 'col-12': metricPages[selectedPage].length === 1 }">
                <kendo-chart [transitions]="false" [style.height.px]="85" style="background-color: #f5f6fb;">
                    <kendo-chart-area opacity="0"></kendo-chart-area>
                    <ng-template kendoChartDonutCenterTemplate>
                        <span class="dash-numeric-medium" title="{{metric.name}}">{{metric.metricValue | roundNumber}}
                        </span>
                    </ng-template>
                    <kendo-chart-series>
                        <kendo-chart-series-item type="donut" [data]="getChartData(i, metricPages[selectedPage])"
                            [margin]="0" [padding]="0" [startAngle]="90" [holeSize]="30" categoryField="name"
                            field="value" colorField="color">
                        </kendo-chart-series-item>
                    </kendo-chart-series>
                    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                </kendo-chart>
                <div class="text-center"><a *ngIf="metric.showHistory" title="{{'SHOW-HISTORY' | translate}}"
                        class="pointer emphasizedLabel" (click)="openHistory(metric)">{{metric.name}}</a><span
                        *ngIf="!metric.showHistory">{{metric.name}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="my-auto p-0 m-0 col-1 text-center">
        <i class="material-icons mr-1 pointer fas fa-chevron-right custom-collapsable" *ngIf="metricPages.length > 1"
            (click)="changePage(true)"></i>
    </div>
</div>
<!--Show audit history-->
<div class="k-overlay" *ngIf="historyDialogOpened"></div>
<kendo-window *ngIf="historyDialogOpened" class="kendo-window" (close)="closeHistory()" [top]="150" [width]="850">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{'WELL-BEING-STATUS-HISTORY' | translate}}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <kendo-chart>
        <kendo-chart-title text="{{historyMetricName}}"></kendo-chart-title>
        <kendo-chart-legend position="bottom" orientation="horizontal"></kendo-chart-legend>
        <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
        <kendo-chart-value-axis>
            <kendo-chart-value-axis-item [min]="0" [max]="10" pane="pane" [title]="{ text: getRiskScoreTitle() }">
            </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [maxDivisions]="10" [baseUnit]="'days'">
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-panes>
            <kendo-chart-pane name="pane" clip="false">
            </kendo-chart-pane>
        </kendo-chart-panes>
        <kendo-chart-series>
            <kendo-chart-series-item type="line" [data]="historyData" field="value" categoryField="createdOn"
                color="#2d73f5">
                <kendo-chart-series-item-tooltip>
                    <ng-template let-value="value" let-createdOn="category">
                        <span [translate]="'RISK-SCORE-CHART'" [translateParams]="{score: value}"></span>
                        {{createdOn | date}}
                    </ng-template>
                </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
        </kendo-chart-series>
    </kendo-chart>
</kendo-window>